let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Vhej")).then(() => parcelRequire('53v0L'));